import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  ReferenceInput,
  SelectInput,
  TextInput,
  ListActions,
  EditButton,
  SelectField,
  SimpleList,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import { GenderOptionsId } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import SecuredComponent from "server/security/SecuredComponent";
import { specialistRequests } from "api/specialistApi";

const AdvancedSpecializationSpecialistFilters = [
  <ReferenceInput
    source="advancedSpecializationId"
    reference={specialistRequests.getAdvancedSpecializationsSelect()}
    alwaysOn
  >
    <SelectInput
      label="ВСД Специалност"
      optionText="nameBg"
      emptyText="Всички"
      style={{ width: 300 }}
    />
  </ReferenceInput>,
  <TextInput
    source="Name"
    label="Имена"
    alwaysOn
  />,
];

const ListAdvancedSpecializationSpecialist = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="ВСД специализанти"
      filters={AdvancedSpecializationSpecialistFilters}
      exporter={false}
      actions={
        <ListActions
          hasCreate={checkPermission(getPermissions(), permissions.canManageAdvancedSpecializationSpecialists)}
        />
      }
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                { label: "Име", value: record?.firstName },
                { label: "Презиме", value: record?.secondName },
                { label: "Фамилия", value: record?.lastName },
              ]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[{ label: "ВСД Специалност", value: record?.advancedSpecializationNameBg }]}
              />
              <MobileListRow fields={[{ label: "ЕГН/ЛНЧ", value: record?.personId }]} />
              <MobileListRow
                fields={[{ label: "Пол", value: <SelectField source="gender" choices={GenderOptionsId} /> }]}
              />
              <MobileListRow fields={[{ label: "Статус", value: record?.statusNameBg }]} />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageAdvancedSpecializationSpecialists}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewAdvancedSpecializationSpecialists}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="firstName"
            label="Име"
            sortable={false}
          />
          <TextField
            source="secondName"
            label="Презиме"
            sortable={false}
          />
          <TextField
            source="lastName"
            label="Фамилия"
            sortable={false}
          />
          <TextField
            source="advancedSpecializationNameBg"
            label="ВСД Специалност"
            sortable={false}
          />
          <TextField
            source="personId"
            label="ЕГН/ЛНЧ"
            sortable={false}
          />
          <SelectField
            source="gender"
            choices={GenderOptionsId}
            label="Пол"
            sortable={false}
          />
          <TextField
            label="Статус"
            source="statusNameBg"
            sortable={false}
          />
          <SecuredComponent permission={permissions.canManageAdvancedSpecializationSpecialists}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewAdvancedSpecializationSpecialists}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListAdvancedSpecializationSpecialist;
